import { Button, Icon } from 'antd';
import React, { Component } from 'react';
import ListFileUpload from './ListFileUpload'
import './styles.css';
import { uploadFileOrder } from './../../utils/orders'
import hanldeException from '../../services/handleException';
import { alertError, alertSuccess } from './../../services/dialog'
import { getIEVersion } from './../../services/helper'
import lang from './../../languages/en'

class UploadFile extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fileUpload: null,
        }
    }

    onChange = (e) => {
        if (e.target.files) {
            let file = e.target.files[0]
            let extension = (file && file.name) ? file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase() : null;
            let allowedExtensions = ['csv', 'tsv', 'xls', 'xlsx']
            if (file) {
                this.handleFile(file, allowedExtensions, extension)
            }
        }
    }

    getTimeZone = () => {
        let offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
        return (offset < 0 ? "+" : "-") + (parseInt(("" + Math.floor(o / 60)).slice(-2)) + ("" + (o % 60)).slice(-2) / 60);
    }

    handleFile = (file, allowedExtensions, extension) => {
        if (allowedExtensions.indexOf(extension) !== -1) {
            let params = {
                mappingId: this.props.mappingId,
                importFile: file,
                timeZone: parseFloat(this.getTimeZone())
            }
            this.props.handleUploadFile(true)
            uploadFileOrder(params).then(res => {
                if (res.data.code === 10001) {
                    this.props.onChangeUploadFile(this.state.fileUpload, res.data.data)
                    this.props.changeActionStep('step2')
                } else if (res.data.code === 221505) {
                    this.props.changeActionStep('step1')
                    alertError(lang.file_not_map_with_mapping)
                } else {
                    this.props.changeActionStep('step1')
                    hanldeException(res)
                }
                this.props.handleUploadFile(false)
            }).catch(err => {
                this.props.changeActionStep('step1')
                hanldeException(err)
            })
            this.setState({
                fileUpload: file
            }, () => {
                document.getElementById("input-upload-file-order-up").value = "";
            })
        } else {
            this.props.changeActionStep('step1')
            alertError(lang.type_file_upload_invalid, lang.format_file_upload);
        }
    }

    validateFile = (file) => {
        let extension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();
        let allowedExtensions = ['csv', 'tsv', 'xls', 'xlsx']
        this.handleFile(file, allowedExtensions, extension)
    }

    dropHandler = (ev) => {
        ev.preventDefault();
        if (getIEVersion() > 1) {
            let file = ev.dataTransfer.files[0]
            if (file) {
                this.validateFile(file)
            }
        } else if (ev.dataTransfer.items) {
            let file = ev.dataTransfer.files[0]
            for (let i = 0; i < ev.dataTransfer.items.length; i++) {
                if (ev.dataTransfer.items[i].kind === 'file') {
                    file = ev.dataTransfer.items[i].getAsFile();
                }
            }
            if (file) {
                this.validateFile(file)
            }
        }
    }

    dragOverHandler = (ev) => {
        ev.preventDefault();
    }

    handleClick = () => {
        window.document.getElementById('input-upload-file-order-up').click()
    }

    render() {
        return (
            <div id='upload-file'>
                <div className='upload-file-input'>
                    <input
                        type='file'
                        className='input-upload-file'
                        accept="file_extension"
                        id='input-upload-file-order-up'
                        onChange={this.onChange}
                    />
                    <Button
                        className='button-upload'
                        onClick={(e) => this.handleClick(e)}
                    >
                        <label
                            className='button-upload-file-order-up'
                        >
                            <div className='icon'><Icon type="upload" /> Browse</div>
                        </label>
                    </Button>
                </div>
                <div className='upload-file-list'>
                    {!this.state.fileUpload ? (
                        <div className='label-upload-file'>{lang.drap_drop_import_file}</div>
                    ) : (
                            <ListFileUpload
                                fileUpload={this.state.fileUpload}
                            />
                        )
                    }
                </div>
            </div>
        );
    }
}

export default UploadFile;


// WEBPACK FOOTER //
// ./src/components/upload-file/index.js